import { Action, ErrorCodes, OperationType, Position } from "puzzle";


export const reopenCompletePing: Action = [{
  condition: '{reopenRequestData} && {reopenRequestData.finished}',
  conditionOperations: [{
    actionType: {
      dispatcherId: 'mainDispatcher'
    },
    name: 'removeReopenInProcess',
    type: OperationType.action
  }, {
    data: {
      template: {
        notification: {
          bind: {
            id: '{processId}'
          }
        }
      }
    },
    moduleName: 'ToastNotifications',
    moduleId: 'ToastNotificationsViewport',
    name: 'addReopenFinishedNotifications',
    args: ['notification', 'reopenRequestData']
  }, {
    condition: '{activeDialog} === "ReopenDialog"',
    conditionOperations: [{
      moduleName: 'ReopenDialog',
      name: 'resetProcessing',
      args: ['reopenRequestData']
    }],
    type: OperationType.conditional
  }, {
    actionType: {
      dispatcherId: 'mainDispatcher'
    },
    name: 'removeReopenDispatcher',
    type: OperationType.action
  }],
  elseOperations: [{
    actionType: {
      delay: 1200
    },
    name: 'reopenCompleteUUIDRequest',
    type: OperationType.stack
  }],
  type: OperationType.conditional
}];

export const reopenCompleteUUIDRequest = [{
  data: {
    template: {
      method: 'post',
      bind: {
        url: "'/submissions/' + {submissionId} + '/reopenTargets'",
      },
      params: {
        bind: {
          searchRequest: '{completeParams.searchRequest}',
          reopenWorkflowId: '{completeParams.reopenWorkflowId}',
          processId: '{reopenRequestData.processId}',
        }
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  mappingName: 'reopenRequestData',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{reopenRequestData}',
      }
    }
  },
  name: 'handleExceptionReopen',
  type: OperationType.action
}, {
  name: 'reopenCompletePing',
  type: OperationType.action
}];

export const reopenCompleteRequest: Action = [{
  data: {
    template: {
      method: 'post',
      bind: {
        url: "'/submissions/' + {submissionId} + '/reopenTargets'",
        params: '{completeParams}'
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  mappingName: 'reopenRequestData',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{reopenRequestData}',
      }
    }
  },
  name: 'handleExceptionReopen',
  type: OperationType.action
}, {
  data: {
    template: {
      bind: {
        processId: '{reopenRequestData.processId}',
      }
    }
  },
  type: OperationType.data
}, {
  moduleName: 'ToastNotifications',
  moduleId: 'ToastNotificationsViewport',
  name: 'setReopenProcessingNotification',
  args: ['processId']
}];

export const reopenCompleteAction: Action = [{
  actionType: {
    dispatcherId: 'mainDispatcher'
  },
  name: 'addReopenInProcess',
  type: OperationType.action
}, {
  data: {
    template: {
      bind: {
        processingTargets: '{completeParams.searchRequest.targetIds}'
      }
    }
  },
  moduleName: 'ReopenDialog',
  name: 'setProcessingTargets',
  args: ['processingTargets', 'reopenInProcess']
}, {
  name: 'reopenCompleteRequest',
  type: OperationType.action
}, {
  name: 'reopenCompletePing',
  type: OperationType.action
}];

export const handleExceptionReopen: Action = [{
  condition: '_.get({responseData}, "response.data.errors")}',
  conditionOperations: [{
    data: {
      template: {
        bind: {
          responseData: '{responseData.response}'
        }
      }
    },
    moduleName: 'ErrorHandler',
    name: 'prepareErrorStrings',
    args: ['responseData', 'endpointPrefix'],
    mappingName: 'errorStrings',
    type: OperationType.addOperationData
  }, {
    placeholders: {
      template: {
        bind: {
          close: '{errorStrings.close}',
          text: '{errorStrings.text}',
          title: '{errorStrings.title}',
          warningType: '{errorStrings.warningType}'
        }
      }
    },
    items: [{
      operations: [{
        name: 'closeAndUnlink',
        type: OperationType.action
      }],
      close: false,
      btnName: 'errorHandler.close',
      btnConfig: {
        pos: Position.start
      }
    }, {
      btnName: 'ESCAPE',
      close: false,
      operations: [{
        name: 'closeAndUnlink',
        type: OperationType.action
      }]
    }],
    className: '{warningType}',
    text: 'errorHandler.text',
    title: 'errorHandler.title',
    type: OperationType.warning
  }, {
    moduleName: 'App',
    type: OperationType.unmaskModule
  }, {
    actionType: {
      dispatcherId: 'mainDispatcher'
    },
    name: 'removeReopenInProcess',
    type: OperationType.action
  }, {
    actionType: {
      dispatcherId: 'mainDispatcher'
    },
    name: 'removeReopenDispatcher',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];